import "Glonass/UI/MenuForm";

/** @namespace Agronomy.UI */
NS("Agronomy.UI");

/**
 * @class
 * @extends Glonass.UI.MenuForm
 */
Agronomy.UI.MenuForm = Class(Glonass.UI.MenuForm, /** @lends Agronomy.UI.MenuForm.prototype */ {
    addItems() {
        this.addItem("map", "Карта", "gl-menu__color_map", "icon-earth", "Spatial.UI.Map");
        this.addItem("spatial", "Пространственные данные", "gl-menu__color_spatial", "icon-sphere", "Spatial.UI.Main");
        this.addItem("spatialMeta", "Пространственные мета данные", "gl-menu__color_spatial-meta", "icon-map2", "SpatialMeta.UI.Main");
        // this.addItem("dicts", "Справочники", "gl-menu__color_dicts", "icon-book2", "Spatial.UI.Dicts");
        this.addItem("accounting", "Система учёта", "gl-menu__color_accounting", "icon-price-tags", "Accounting.UI.Main");
        this.addItem("settings", "Управление", "gl-menu__color_admin", "icon-cogs", "Security.UI.Admin");

        return this;
    }
});
